<div class="container my-5">
  <div class="row">
    <div class="main-container col-12 text-center">
      <div class="text-center col-md-6 offset-md-3">
        <img class="img container" src="/assets/images/chain-repair.jpeg" alt="Event 404">
      </div>
      <h2 class="my-1">Event Not Found</h2>
      <a class="btn btn-primary mt-3 mb-5" href="https://usacycling.org/events">Search Upcoming Events</a>
    </div>
  </div>
</div>
